import {
  RECEIVE_SHIPMENT_TRACKING,
  RECEIVE_SHIPMENT_TRACKING_ERROR,
  REQUEST_SHIPMENT_TRACKING,
  RESET_SHIPMENT_TRACKING
} from 'constants/reduxActions';
import { fetchErrorMiddlewareMaybeJson } from 'middleware/fetchErrorMiddleware';
import { getTracking } from 'apis/account';
import { trackError } from 'helpers/ErrorUtils';
import { selectAccountConfig } from 'selectors/environment';

export function requestShipmentTracking() {
  return {
    type: REQUEST_SHIPMENT_TRACKING
  };
}

export function receiveShipmentTracking(trackingInfo) {
  return {
    type: RECEIVE_SHIPMENT_TRACKING,
    trackingInfo
  };
}

export function receiveShipmentTrackingError() {
  return {
    type: RECEIVE_SHIPMENT_TRACKING_ERROR
  };
}

export function resetShipmentTracking() {
  return {
    type: RESET_SHIPMENT_TRACKING
  };
}

export function fetchShipmentTracking(orderId, shipmentId, getTrackingEndpoint = getTracking) {
  return (dispatch, getState) => {
    dispatch(requestShipmentTracking());

    const accountConfig = selectAccountConfig(getState());

    return getTrackingEndpoint(accountConfig, orderId, shipmentId)
      .then(fetchErrorMiddlewareMaybeJson)
      .then(resp => {
        dispatch(receiveShipmentTracking(resp));
      })
      .catch(e => {
        trackError('NON-FATAL', 'Problem loading shipment tracking data.', e);
        dispatch(receiveShipmentTrackingError());
      });
  };
}
